import { HTMLProps, ReactNode, useEffect, useRef, useState } from "react";
import { Btn } from "./styles";

type ButtonProps = Omit<HTMLProps<HTMLButtonElement>, "type">;
type CustomProps = {
  children: ReactNode;
  type?: "button" | "submit" | "reset";
  isLoading?: boolean;
  danger?: boolean;
};
type Props = ButtonProps & CustomProps;
export function PrimaryButton({
  children,
  danger,
  isLoading,
  ...btn_props
}: Props) {
  return (
    <Btn
      {...btn_props}
      $danger={danger}
      disabled={btn_props.disabled || isLoading}
    >
      <div className="decorator" />
      <div className="text">
        {isLoading ? (
          <>
            <span className="spin" /> Cargando...
          </>
        ) : (
          children
        )}
      </div>
    </Btn>
  );
}
